<template>
	<div class="col-12">
		<div class="row gutter-xs">
			<div class="col-xs-12 col-sm-9">
				<q-input
					type="number"
					v-model="days"
					:float-label="$t('certificate_expiration_label')"
					:disable="disableInput"
				/>
			</div>
			<div class="col-xs-12 col-sm-2">
				<q-select
					:disable="disableInput"
					v-model="type_calendar"
					:options="listed_type_calendar"
					:float-label="' '"
				/>
			</div>
			<div style="padding: 10px 2px;">
				<q-icon
					name="far fa-question-circle"
					size="1.5rem"
					color="grey"
					class="q-mr-sm q-pt-md"
				>
					<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
						<p class="q-ma-xs q-pa-xs">
							{{ $t('expire_certificate_information_1') }}
						</p>
						<p class="q-ma-xs q-pa-xs">
							{{ $t('expire_certificate_information_2') }}
						</p>
					</q-tooltip>
				</q-icon>
			</div>
		</div>
	</div>
</template>

<script>
import { debounce } from 'quasar'

export default {
	name: 'InputExpireCertificate',
	i18nOptions: { namespaces: ['fortraders', 'common'] },

	props: {
		disableInput: {
			type: Boolean,
			require: true,
		},
		qty_days: {
			type: Number,
		},
	},

	data() {
		return {
			type_calendar: 1,
			listed_type_calendar: [
				{ label: this.$t('days'), value: 1 },
				{ label: this.$t('months'), value: 30 },
				{ label: this.$t('years'), value: 365 },
			],
			days: '',
			debouncedFn: '',
		}
	},

	methods: {
		calculationDays() {
			this.debouncedFn()
		},
		updateTypeCalendar(value) {
			this.type_calendar = value
		},
	},

	watch: {
		days: function() {
			this.calculationDays()
		},

		type_calendar: function() {
			this.days = 0
		},

		qty_days: function() {
			this.days = this.qty_days
			this.calculationDays()
		},
	},

	mounted() {
		this.debouncedFn = debounce(() => {
			let days = this.days * this.type_calendar
			this.$emit('fnInDays', days)
		}, 1000)
	},

	created() {
		console.log(this.qty_days)
	},
}
</script>
